<template>
<v-card>
  <v-card-title>
    <span class="headline">Share</span>
  </v-card-title>
  <v-card-text>
    <v-container>
        <v-layout row>
          <v-flex xs12>
            <v-text-field
              v-model="email.address"
              label="Add Collaborator(s)"
              placeholder="Enter an email address"
              type="text"
              clearable
              :append-outer-icon="'add'"
              @click:append-outer="addCollab"
              v-on:keyup="addCollabOnEnter">
            </v-text-field>
          </v-flex>
        </v-layout>
        <p id="error-message" v-show="error.length > 0"> {{ error }} </p>
        <span
          v-for="(item,index) in emails"
          :key="index">
          <v-btn
            @click="removeCollab(index)"
            @mouseover="mouseOver(item)"
            @mouseleave="mouseLeave(item)"
            depressed small>
            {{ item.address }}
            <v-icon v-show="item.isActive" dark right> clear </v-icon>
          </v-btn>
        </span>
    </v-container>
  </v-card-text>
  <v-card-actions>
    <v-spacer></v-spacer>
    <!--v-btn color="blue darken-1" flat @click="close">Close</v-btn-->
    <!-- <v-btn color="blue darken-1" flat @click="dialog = false">Save</v-btn> -->
  </v-card-actions>
</v-card>
</template>

<script>
import {db} from '../../firebaseDB'

export default {
  name: 'share-asset-card',
  props: {
    asset: null,
    assetType: null
  },
  data () {
    return {
      email: {
        isActive: false,  // delete button not active
        address: null     // input email address
      },
      emails: [],   // list of email objects for view
      collabs: [],  // list of email addresses for db storage
      error: '',    // error message for invalid email input
      users: []     // user objects pulled from db
    }
  },
  created () {
    this.pullCollabsFromDB()
    this.pullUsersFromDB()
  },
  methods: {
    close () {
      this.$emit('close')
    },

    // add a collaborator on btn click
    addCollab () {
      if (!this.email.address || !this.isValidEmail(this.email.address)) {
        this.error = 'Please enter a valid email!'
        return false
      }

      if (this.email.address === this.$store.state.user.email) {
        this.error = 'You cannot add yourself as a collaborator!'
        return false
      }

      if (this.collabs.includes(this.email.address)) {
        this.error = 'You have already added this collaborator!'
        return false
      }

      if (this.collabExists(this.email.address)) {
        let emailToSave = {}
        emailToSave = Object.assign(emailToSave, this.email)
        this.emails.push(emailToSave)
        this.collabs.push(this.email.address)
        this.email.address = ''
        this.error = ''
        this.updateAssetDB()
        // this.updateUserDB('add')
        // this.$store.dispatch('pullStories')
        return true
      } else {
        this.error = 'An account associated with this email does not exist!'
        return false
      }
    },

    // add a collaborator on enter key
    addCollabOnEnter (e) {
      if (e.keyCode === 13) {
        this.addCollab()
      }
    },

    // remove a collaborator
    removeCollab (index) {
      // let collabID = this.getCollabID()
      // this.updateUserDB(collabID[index])
      this.emails.splice(index, 1)
      this.collabs.splice(index, 1)
      this.updateAssetDB()
    },

    // update asset objects in db
    updateAssetDB () {
      console.log(`assets/asset_data/${this.assetType}/${this.asset.id}/meta_data/collaborators`)
      console.log(this.collabs)
      db.ref(`assets/asset_data/${this.assetType}/${this.asset.id}/meta_data/collaborators`).set(this.collabs)
    },

    // update user objects in db
    updateUserDB (action) {
      const collabID = this.getCollabID()
      if (action === 'add') {
        for (let id of collabID) {
          if (id !== -1) {
            db.ref(`users/${id}/stories/${this.storyID}`).set('collaborator')
          }
        }
      } else {
        if (action !== -1) {
          db.ref(`users/${action}/stories/${this.storyID}`).set([])
        }
      }
    },

    // retrieve list of collaborators from db if exists
    pullCollabsFromDB () {
      this.emails = []
      this.collabs = []
      db.ref(`assets/asset_data/${this.assetType}/${this.asset.id}/meta_data`)
      .once('value')
      .then(snapshot => {
        if (snapshot.val() && snapshot.val().hasOwnProperty('collaborators')) {
          this.collabs = Object.assign(this.collabs, snapshot.val().collaborators)
          this.collabs.forEach((item) => {
            this.emails.push({ 'isActive': false, 'address': item })
          })
        }
      })
    },

    // retrieve user objects from db
    pullUsersFromDB () {
      db.ref(`users`)
      .once('value')
      .then(snapshot => {
        let entries = Object.entries(snapshot.val())
        for (let entry of entries) {
          this.users.push(entry)
        }
      })
    },

    // obtain list of collaborator ids
    getCollabID () {
      let collabID = []
      let flag = false  // flag for if collab id is found
      for (let email of this.collabs) {
        flag = false
        for (let user of this.users) {
          if (user[1].email === email) {
            collabID.push(user[0])
            flag = true
            break
          }
        }
        if (flag === false) {
          collabID.push(-1)
        }
      }
      return collabID
    },

    collabExists (email) {
      for (let user of this.users) {
        if (user[1].email === email) {
          return true
        }
      }
      return false
    },

    // mouse over to show delete button
    mouseOver (item) {
      item.isActive = true
    },

    // mouse leave to hide delete button
    mouseLeave (item) {
      item.isActive = false
    },

    // check if input is a valid email address
    isValidEmail (email) {
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    }
  }
}
</script>

<style scoped>
#error-message {
  color: red
}
</style>



// WEBPACK FOOTER //
// src/components/assets/shareAssetCard.vue